import React, { useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { InfoButton } from '../../FormWidgets/Description';
import { formatDatabaseSetting } from '../../Utils/database_history_utils';

export default function SettingsRequestDetails({ fields, fieldLabel }) {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [showUncompared, setShowUncompared] = useState(false);
  const changed = fields.filter((field) => field.compared);
  const unknown = fields.length - changed.length;
  const visible = showUncompared ? fields : changed;
  const lastPage = Math.max(0, Math.ceil(visible.length / 25) - 1);
  const currentPage = Math.min(page, lastPage);
  return <Box my={1}>
    <Box display="flex" alignItems="center">
      <Typography variant="subtitle2">{t('database_requested_settings')}</Typography>
      <InfoButton brief={t('database_requested_settings')} content={t('database_request_summary_help')} />
    </Box>
    {!changed.length && <Typography color="textSecondary">{t(unknown ? 'database_request_comparison_unavailable' : 'database_request_no_difference')}</Typography>}
    {unknown > 0 && <Button size="small" onClick={() => { setShowUncompared(!showUncompared); setPage(0); }}>
      {t(showUncompared ? 'database_hide_uncompared' : 'database_show_uncompared', { count: unknown })}
    </Button>}
    {visible.slice(currentPage * 25, currentPage * 25 + 25).map((field) => <Box key={JSON.stringify(field.path)} my={1}>
      <Typography variant="body2">{fieldLabel(field.path.join('.'))}</Typography>
      <Typography color="primary">{formatDatabaseSetting(field.path, field.requested, t)}</Typography>
      {!field.compared && <Typography variant="caption" color="textSecondary">{t('database_request_comparison_unavailable')}</Typography>}
      {Object.prototype.hasOwnProperty.call(field, 'previous') && <Typography variant="caption" color="textSecondary">
        {t('database_previously_reported')}: {formatDatabaseSetting(field.path, field.previous, t)}
      </Typography>}
    </Box>)}
    {lastPage > 0 && <Box display="flex" justifyContent="flex-end">
      <Button disabled={!currentPage} onClick={() => setPage(currentPage - 1)}>{t('database_previous_page')}</Button>
      <Button disabled={currentPage === lastPage} onClick={() => setPage(currentPage + 1)}>{t('database_next_page')}</Button>
    </Box>}
  </Box>;
}
